<script setup lang="ts">
// The lockup: the mark and the wordmark in the brand's own proportions
// (docs/design/majlis-logo, from its lockup.svg), in one place. `size` is the
// wordmark's em in px: the mark is .947×.795 of it, the gap .41, the word
// 2.696×.921, and the mark's centre sits .032em above the word's, as the master
// has it. 96px is the lockup's minimum width, so size stays at 24 or more.
// `markOnly` keeps the mark alone (the collapsed sidebar); `decorative` when the
// parent carries the name, otherwise the wordmark is the image "Majlis".
import BrandMark from "@/components/ui/BrandMark.vue";
import BrandWord from "@/components/ui/BrandWord.vue";

withDefaults(defineProps<{ size?: number; markOnly?: boolean; decorative?: boolean }>(), { size: 28 });
</script>

<template>
  <span class="lockup" :style="{ '--em': `${size}px` }">
    <BrandMark class="mark" />
    <BrandWord v-if="!markOnly" class="word" :decorative="decorative" />
  </span>
</template>

<style scoped>
.lockup { display: inline-flex; align-items: center; gap: calc(var(--em) * .41); color: var(--ink); line-height: 0; }
.mark { width: calc(var(--em) * .947); height: calc(var(--em) * .795); flex: none; position: relative; }
.mark:not(:only-child) { top: calc(var(--em) * -.032); }
.word { width: calc(var(--em) * 2.696); height: calc(var(--em) * .921); flex: none; }
</style>
